import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import flipIcon from '../../assets/flip.png';
import closeIcon from '../../assets/closeIcon.png';
import friendsIcon from '../../assets/friends.png';
import earnIcon from '../../assets/earn.png';
import boostsIcon from '../../assets/boosts.png';
import presaleIcon from '../../assets/presale.png';
import homeIcon from '../../assets/home.png'

import "./NavBar.css"

const NavBar = () =>{

    const [isOpen, setIsOpen] = useState(false);

    const navigate = useNavigate();

    const flip = () => { navigate('/'); }
    const friends = () => { navigate('/invite'); }
    const earn = () => { navigate('/earn'); }
    const boosts = () => { navigate('/boosts'); }
    const handleClickPreSale = () => {
        // navigate('/presale');
        setIsOpen(true);
    }

    const onClose = () =>{
        setIsOpen(false);
    }


    return (
        <>
            {isOpen?<div className="modal-overlay" style={{backdropFilter:"blur(0.5rem)"}}>
                <div className="modal" style={{backgroundColor:"#25262c"}}>
                    <div className="modal-header" style={{marginTop:"5px"}}>
                        <img src={presaleIcon} alt="Energy Modal Icon" className="modal-icon" />
                        <button style={{ position: 'absolute', top: '0rem', right: '0rem', float: 'right', background: 'none', border: 'none', cursor: 'pointer' }} onClick={onClose}>
                            <img src={closeIcon} alt="Close Icon" style={{ width: '1.5rem', height: '1.5rem' }} />
                        </button>
                    </div>
                    <div className="modal-title">
                        <h2>Mooncoin Raffles</h2>
                    </div>
                    <div className="modal-body">
                        <p className="modal-message">Use your Mooncoins to enter Mooncoin Raffles and Win Big</p>
                    </div>
                    <div className="modal-footer">
                        <button className="modal-button" style={{marginBottom:"13px"}}>
                            Coming Soon!
                        </button>
                    </div>
                </div>
            </div>:""}
            <div className="button-row">
                <button className="button-item" onClick={flip}  style={{display:'flex', justifyContent:'space-around'}}>
                    <img src={homeIcon} alt="Flip x2" className="icon" />
                    <span>Home</span>
                </button>
                <button className="button-item" onClick={friends}>
                    <img src={friendsIcon} alt="Friends" className="icon" />
                    <span>Friends</span>
                </button>
                <button className="button-item" onClick={earn}>
                    <img src={earnIcon} alt="Earn" className="icon" />
                    <span>Earn</span>
                </button>
                <button className="button-item" onClick={boosts}>
                    <img src={boostsIcon} alt="Boosts" className="icon" />
                    <span>Boosts</span>
                </button>
                <button className="button-item" onClick={handleClickPreSale}>
                    <img src={presaleIcon} alt="presale" className="icon" />
                    <span>Raffles</span>
                </button>
            </div>
        </>
    )
}

export default NavBar;